import AddIcon from './component'

export default AddIcon